import { useState } from "react";

import Eyebrow from "../shared/Eyebrow";
import TypedHeading from "../shared/TypedHeading";
import Reveal from "../shared/Reveal";
import useI18n from "../../i18n/useI18n";

const FAQ = () => {
  const { t } = useI18n();
  const items = t("faq.items");
  const [openIndex, setOpenIndex] = useState(null);

  const toggle = (index) => {
    setOpenIndex((current) => (current === index ? null : index));
  };

  return (
    <section id="faq" className="faq section section--alt">
      <div className="faq__inner">
        <div className="faq__aside">
          <Reveal><Eyebrow>{t("faq.eyebrow")}</Eyebrow></Reveal>
          <TypedHeading text={t("faq.title")} className="faq__title" />
        </div>

        <Reveal className="faq__list">
          {Array.isArray(items) &&
            items.map((item, i) => {
              const isOpen = openIndex === i;
              return (
                <div className={`faq-item${isOpen ? " is-open" : ""}`} key={i}>
                  <button
                    type="button"
                    className="faq-item__btn"
                    aria-expanded={isOpen}
                    onClick={() => toggle(i)}
                  >
                    <span className="faq-item__q">{item.q}</span>
                    <span className="faq-item__icon" aria-hidden="true">+</span>
                  </button>
                  <div className="faq-item__body" hidden={!isOpen}>
                    <p>{item.a}</p>
                  </div>
                </div>
              );
            })}
        </Reveal>
      </div>
    </section>
  );
};

export default FAQ;
